import React from "react";

const CINEPauseSmall = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M0 16H5.33333V0H0V16ZM10.6667 0V16H16V0H10.6667Z"
        fill="white"
      />
    </svg>
  );
};

export default CINEPauseSmall;
